import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CategoryVppApplicationsEffects } from './category-vpp-applications.effects';
import { categoryVppApplicationsReducer } from './category-vpp-applications.reducer';

export const provideCategoryVppApplicationsStore = () => [
  provideState('categoryVppApplications', categoryVppApplicationsReducer),
  provideEffects([CategoryVppApplicationsEffects]),
];
